import { VoteController } from 'api/controllers/VoteController';
import { VoteData } from 'api/controllers/typings';
import { useTemplateMutation } from '../templates';
import { GET_CURRENT_VOTING_STATISTICS } from '../queryKeys';

export const useAddVote = useTemplateMutation<VoteData>({
  mutationFn: data => VoteController.addVote(data),
  refetchQueries: [GET_CURRENT_VOTING_STATISTICS],
});
